<template>
  <div v-if="estaLogueado" style="display: inline-block;">
    <v-menu offset-y left :close-on-content-click="true">
      <template v-slot:activator="{ on }">
        <v-avatar size="36" class="elevation-2" style="cursor: pointer;" v-on="on">
          <img
            v-if="linkPhoto && !avatarError"
            :src="serverUrl + 'api/principal/get_image/' + identificador + '/' + linkPhoto"
            @error="avatarError = true"
          />
          <v-icon v-else color="white" size="36">mdi-account-circle</v-icon>
        </v-avatar>
      </template>
      <v-card min-width="180" class="pa-1">
        <v-list dense>
          <v-list-item @click="irATienda">
            <v-list-item-icon><v-icon>mdi-store</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Ir a la Tienda</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="irAlBlog">
            <v-list-item-icon><v-icon color="teal">mdi-post-outline</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Blog</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="irAEventos">
            <v-list-item-icon><v-icon color="deep-purple">mdi-calendar-star</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Eventos</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="irALinksTec">
            <v-list-item-icon><v-icon color="blue darken-2">mdi-link-variant</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Gestor de enlaces</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="irAlCarrito">
            <v-list-item-icon><v-icon color="orange darken-2">mdi-cart</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Mi Carrito</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="irAMiCuenta">
            <v-list-item-icon><v-icon>mdi-account-cog</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Mi Cuenta</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-list-item @click="irAMisPedidos">
            <v-list-item-icon><v-icon>mdi-clipboard-list</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title>Mis Pedidos</v-list-item-title></v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="cerrarSesion">
            <v-list-item-icon><v-icon color="red">mdi-logout</v-icon></v-list-item-icon>
            <v-list-item-content><v-list-item-title style="color: red;">Cerrar Sesión</v-list-item-title></v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { http } from '@/services/config';

export default {
  name: 'AvatarUsuario',

  data() {
    return {
      avatarError: false,
      serverUrl: http.defaults.baseURL
    };
  },

  computed: {
    estaLogueado() {
      return this.$store.getters.estaLogueado;
    },
    identificador() {
      return this.$store.getters.identificadorUsuario;
    },
    linkPhoto() {
      return this.$store.getters.linkPhotoUsuario;
    }
  },

  methods: {
    irATienda() {
      this.$router.push('/store/all').catch(() => {});
    },
    irAlBlog() {
      this.$router.push('/blog').catch(() => {});
    },
    irAEventos() {
      this.$router.push('/eventos').catch(() => {});
    },
    irALinksTec() {
      this.$router.push('/linkstec').catch(() => {});
    },
    irAlCarrito() {
      this.$router.push('/store-carrito').catch(() => {});
    },
    irAMiCuenta() {
      this.$router.push('/data_user').catch(() => {});
    },
    irAMisPedidos() {
      this.$router.push('/mis-pedidos').catch(() => {});
    },
    cerrarSesion() {
      localStorage.removeItem('token');
      localStorage.removeItem('identificador');
      localStorage.removeItem('linkPhoto');
      this.$store.commit('vaciarCarrito');
      this.$store.commit('setLogueado', false);
      this.$store.commit('setIdentificador', '');
      this.$store.commit('setLinkPhoto', '');
      this.avatarError = false;
      this.$router.push('/store/all');
    }
  }
};
</script>
